import { useState, useEffect } from 'react';

const PromoBanner = () => {
  // Check localStorage to see if user has previously closed the banner
  const [isClosed, setIsClosed] = useState(() => {
    const savedState = localStorage.getItem('promoBannerClosed');
    return savedState === 'true';
  });
  const [isVisible, setIsVisible] = useState(false);

  // Function to handle closing the banner
  const handleClose = () => {
    setIsClosed(true);
    // Save the closed state in localStorage
    localStorage.setItem('promoBannerClosed', 'true');
  };

  useEffect(() => {
    // Function to handle scroll event
    const handleScroll = () => {
      // Get the height of the viewport
      const viewportHeight = window.innerHeight;
      
      // Show banner after scrolling past 50% of the viewport height
      // This should be after the hero section but not too far down
      if (window.scrollY > viewportHeight * 0.5) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Add event listener
    window.addEventListener('scroll', handleScroll);
    
    // Clean up event listener
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Don't render if closed or not visible yet
  if (isClosed || !isVisible) return null;

  return (
    <div className="bg-[#0a2672] text-white text-sm py-2 px-4 fixed left-0 right-0 z-40 shadow-md transition-all duration-300 ease-in-out" style={{ top: '60px', transform: isVisible ? 'translateY(0)' : 'translateY(-100%)' }}>
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex-1 text-center font-medium px-4">
          <span className="hidden md:inline">Help improve your credit score! </span>
          Get a FREE one-month trial of credit reports and monitoring
        </div>
        <div className="flex items-center space-x-4">
          <a href="https://app.futeur.ai/signup" target="_blank" rel="noopener noreferrer" className="hover:underline font-medium">Get Started</a>
          <button 
            onClick={handleClose}
            className="text-white opacity-80 hover:opacity-100"
            aria-label="Close banner"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
